import { Location } from '@angular/common';
import { LinkRefusal } from './link-refusal';
import { LinkResult, linkResultMessage } from './link-result';

export interface LinkNotice {
  key: string;
  params?: { count: number };
  refused: boolean;
  // The device is linked but nothing was bound, which only the checklist can put right.
  offersChecklist: boolean;
}

export function linkedNotice(result: LinkResult): LinkNotice {
  const { key, params } = linkResultMessage(result);
  return { key, params, refused: false, offersChecklist: result.boundCount === 0 };
}

export function refusedNotice(refusal: LinkRefusal): LinkNotice {
  return { key: refusal.messageKey, refused: true, offersChecklist: false };
}

const STATE_KEY = 'linkNotice';

// The create dialog opens the installation's page and hands over how linking the device went.
export function linkNoticeState(notice: LinkNotice): Record<string, LinkNotice> {
  return { [STATE_KEY]: notice };
}

// A page reads the hand-over once. Left in the history entry it would show again after a reload
// and when the user comes back to the entry.
export function takeLinkNotice(location: Location): LinkNotice | null {
  const state = location.getState() as Record<string, unknown> | null;
  const notice = state?.[STATE_KEY] as LinkNotice | undefined;
  if (!notice) return null;
  location.replaceState(location.path(), '', { ...state, [STATE_KEY]: undefined });
  return notice;
}
